import Vue from "vue"
import App from "./App.vue"

import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import axios from "axios"

import settings from "./api/settings"

import Vue2TouchEvents from "vue2-touch-events"
import VueClipboard from "vue-clipboard2"
import Vuelidate from "vuelidate"
import VueMeta from "vue-meta"

Vue.use(Vuelidate)
Vue.use(Vue2TouchEvents)
Vue.use(VueClipboard)
Vue.use(VueMeta)

const { apiSettings } = settings
let API_URL = apiSettings.url

axios.defaults.baseURL = API_URL

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app")
